module.exports = __webpack_public_path__ + "img/price-2.c0c2faf2.png";